export default __webpack_public_path__ + "static/media/vpWar.34bb8035.svg";